import React, { Component } from 'react'
import ReactTags from 'react-tag-autocomplete'

import './styles/tag-autocomplete.scss'

export default class TagAutocomplete extends Component {
  render() {
    const { tags, suggestions, onDelete, onAdd } = this.props

    return (
      <ReactTags
        tags={tags}
        suggestions={suggestions}
        handleDelete={onDelete}
        handleAddition={onAdd}
        autofocus={false}
        placeholder={null}
        autoresize={false}
        allowBackspace={false}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TagAutocomplete.js